module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "banner_play.8b235909.svg";